export const safeDispatch = event => global?.dataLayer?.push?.(event);

export default {
  sendImpressionsForListingAgentEvent: ({ expertContactId, propertyId }) => {
    safeDispatch({
      event: "custom_event",
      event_category: "sales_show",
      event_action: "impressions_for_listing_agent",
      event_label: `expert_contact_id=${expertContactId}|property_id=${propertyId}`
    });
  },
  sendContactListingAgentEvent: ({ expertContactId, propertyId, uuid }) => {
    safeDispatch({
      event: "custom_event",
      event_category: "sales_show",
      event_action: "contact_listing_agent",
      event_label: `expert_contact_id=${expertContactId}|uuid=${uuid}|property_id=${propertyId}`
    });
  },
  sendClickToSellHomepageEvent: ({ expertContactId, propertyId, uuid }) => {
    safeDispatch({
      event: "custom_event",
      event_category: "sales_show",
      event_action: "click_to_sell_homepage",
      event_label: `expert_contact_id=${expertContactId}|uuid=${uuid}|property_id=${propertyId}`
    });
  }
};
